module.exports = __webpack_public_path__ + "img/mobile_background_section4.74ea9b09.svg";